import { JSX } from 'react'

import { IconProps } from '../../icon'

const NoMeDigas: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 32 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M0.117676 16.0249C0.117676 7.17835 7.23321 0 16.0141 0C24.795 0 31.9105 7.17835 31.9105 16.0249C31.9105 24.8715 24.795 31.9993 16.0141 31.9993C7.23321 31.9993 0.117676 24.8209 0.117676 16.0249Z'
      fill='#FECC5B'
    />
    <path
      d='M24.3408 2.32611C25.9053 4.80315 26.8641 7.7857 26.8641 10.9705C26.8641 19.817 19.7486 26.9954 10.9677 26.9954C7.93979 26.9954 5.0633 26.136 2.64099 24.6194C5.46702 29.068 10.4126 32 16.0142 32C24.795 32 31.9106 24.8216 31.9106 15.9751C31.9106 10.2122 28.8827 5.15701 24.3408 2.32611Z'
      fill='#FCC154'
    />
    <path
      d='M2.28747 17.693C2.28747 9.50366 8.89836 2.83083 17.0232 2.83083C21.7669 2.83083 26.0059 5.10566 28.731 8.64428C26.2078 4.19573 21.4136 1.21318 15.913 1.21318C7.78813 1.16262 1.17725 7.83546 1.17725 16.0248C1.17725 19.4118 2.33794 22.5966 4.2556 25.0736C2.99398 22.8999 2.28747 20.3723 2.28747 17.693Z'
      fill='#FED27F'
    />
    <path
      d='M11.3206 12.1325C11.3206 13.2446 10.816 14.104 10.16 14.104C9.50392 14.104 8.99927 13.194 8.99927 12.1325C8.99927 11.0203 9.50392 10.1609 10.16 10.1609C10.816 10.1104 11.3206 11.0203 11.3206 12.1325Z'
      fill='#2C2D2D'
    />
    <path
      d='M23.0284 12.1325C23.0284 13.2446 22.5238 14.104 21.8677 14.104C21.2117 14.104 20.707 13.194 20.707 12.1325C20.707 11.0203 21.2117 10.1609 21.8677 10.1609C22.5238 10.1104 23.0284 11.0203 23.0284 12.1325Z'
      fill='#2C2D2D'
    />
    <path
      d='M18.8908 20.4735C18.8908 23.2033 17.6292 25.377 16.0143 25.377C14.3994 25.377 13.1378 23.2033 13.1378 20.4735C13.1378 17.7437 14.3994 15.5699 16.0143 15.5699C17.6292 15.5699 18.8908 17.7942 18.8908 20.4735Z'
      fill='#725340'
    />
    <path
      d='M18.4359 23.1025C16.3668 21.9398 14.651 22.597 13.6417 23.2542C14.1464 24.518 15.0043 25.3774 16.0136 25.3774C17.0229 25.3774 17.9312 24.4674 18.4359 23.1025Z'
      fill='#EC646E'
    />
  </svg>
)

export default NoMeDigas
